import Modal from "../../../components/Modal/Modal"
import styles from './FriendsModal.module.css'
import spinnerBall from '../../../assets/spinnerBall.webp'

const FriendsModal = () => {
    return (
        <Modal>
            <div className={styles.container}>
                <div className={styles.bonusIcon}></div>
                <div className={styles.textContainer}>
                    <div className={styles.headText}>
                        Получай бонусные спины!
                    </div>
                    <div className={styles.descText}>
                        Получай бонусные спины когда твои друзья повышают уровень
                    </div>
                </div>
                <div className={styles.lvlBlockContainer}>
                    <div className={styles.lvlBlock}>
                        <div className={styles.lvlBlock__textContainer}>
                            <div className={styles.lvlBlock__count}>
                                LVL 1
                            </div>
                            <div className={styles.lvlBlock__text}>
                                Друг должен прокрутить<br />50 спинов
                            </div>
                        </div>
                        <div className={styles.lvlBlock__reward}>
                            <p>+5</p>
                            <img width={20} height={20} src={spinnerBall} />
                        </div>
                    </div>
                    <div className={styles.lvlBlock}>
                        <div className={styles.lvlBlock__textContainer}>
                            <div className={styles.lvlBlock__count}>
                                LVL 2
                            </div>
                            <div className={styles.lvlBlock__text}>
                                Друг должен прокрутить<br />100 спинов
                            </div>
                        </div>
                        <div className={styles.lvlBlock__reward}>
                            <p>+10</p>
                            <img width={20} height={20} src={spinnerBall} />
                        </div>
                    </div>
                    <div className={styles.lvlBlock}>
                        <div className={styles.lvlBlock__textContainer}>
                            <div className={styles.lvlBlock__count}>
                                LVL 3
                            </div>
                            <div className={styles.lvlBlock__text}>
                                Друг должен прокрутить<br />150 спинов
                            </div>
                        </div>
                        <div className={styles.lvlBlock__reward}>
                            <p>+20</p>
                            <img width={20} height={20} src={spinnerBall} />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default FriendsModal